<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'medicalAlert', params: {} }">
            Medical Alert
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'medicalAlertView', params: {} }">
              View Medical Alert
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Medical Alert
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="medicalAlert.name">
            <td max-width="35%" class="text-subtitle-1">Name:</td>
            <td>{{ medicalAlert.name }}</td>
          </tr>
          
          <tr v-if="medicalAlert.description">
            <td max-width="35%" class="text-subtitle-1">Description:</td>
            <td>{{ medicalAlert.description }}</td>
          </tr>
          
          <tr v-if="medicalAlert.withOptions">
            <td max-width="35%" class="text-subtitle-1">Has Options:</td>
            <td>{{ medicalAlert.withOptions }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getMedicalAlert } from "@/services/medicalAlert";
    

    export default {
      data() {
        return {
            id: '',
            medicalAlert: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "medicalAlertEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getMedicalAlert(this.id)
            .then((response) => {
              this.medicalAlert = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading medicalAlert");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    